"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>ReviewSection
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const horizon_namespaceObject = require("@pcln/horizon");
require("react");
const ReviewSection_ReviewSection = ({ type, text })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        children: 'up' === type ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.Inclusion, {
            labelNode: text,
            size: 'sm',
            icon: "thumb_up",
            slots: {
                inclusionSlot: 'text-benefit-8',
                iconSlot: '!hidden',
                inclusionIconSlot: 'text-benefit-8'
            }
        }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.Inclusion, {
            labelNode: text,
            size: 'sm',
            icon: "thumb_down",
            slots: {
                inclusionSlot: 'text-benefit-8',
                iconSlot: '!hidden',
                inclusionIconSlot: 'text-neutral-10'
            }
        })
    });
const ReviewSection = ReviewSection_ReviewSection;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
